// extracted by mini-css-extract-plugin
export var auto = "_26-1";
export var spinner = "_26-0";